/** Pixel sizes for site-template icons (blocks + SSR HTML). */
export const SITE_ICON_SIZES = {
  sm: 16,
  md: 20,
  lg: 24,
} as const;

export type SiteIconSizeToken = keyof typeof SITE_ICON_SIZES;

export function resolveSiteIconSize(size: number | SiteIconSizeToken = 'md'): number {
  return typeof size === 'number' ? size : SITE_ICON_SIZES[size];
}
